export enum LeadJournalEntryType {
Created,
StatusChange,
FileUploaded,
UpdateAction,
Terminated,
TaskAdded,
}
